export default class MenuItem {
    constructor(value, data) {
        this.value = value;
        this.data = data;
    }
}